import React from "react";
import { withStyles } from "@material-ui/core/styles";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { __t } from "@core/translation/translation";
import Typography from "@components/Typography";

const IOSSwitch = withStyles(theme => ({
  root: {
    width: 35,
    height: 20,
    padding: 0,
    margin: theme.spacing(1),

    "& .MuiSwitch-switchBase.MuiIconButton-root": {
      padding: "0!important"
    }
  },
  form: {
    "& .MuiFormControlLabel-root": {
      display: "grid"
    }
  },
  switchBase: {
    padding: 1,

    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#52d869",
        opacity: 1,
        border: "none"
      }
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff"
    }
  },
  thumb: {
    width: 19,
    height: 19
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"])
  },
  checked: {},
  focusVisible: {}
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked
      }}
      {...props}
    />
  );
});

export default function CustomizedSwitches({
  variant,
  afterLabel,
  beforeLabel,
  checked,
  setChecked,
  withoutLabel,
  onChange
}) {
  const handleChange = () => {
    setChecked(!checked);
    onChange && onChange();
  };
  const onOrOff = checked ? __t("On") : __t("Off");
  const activeOrInactive = checked ? __t("Active") : __t("Inactive");
  const yesOrNo = checked ? __t("Yes") : __t("No");
  return (
    <FormGroup
      style={{
        width: "150px",
        flexDirection: "inherit",
        justifyContent: "flex-end"
      }}
    >
      {beforeLabel && (
        <>
          {!withoutLabel && (
            <Typography
              color={checked ? "secondary.tint90" : "secondary.tint40"}
            >
              {variant === "onOrOff"
                ? onOrOff
                : variant === "activeOrInactive"
                ? activeOrInactive
                : yesOrNo}
            </Typography>
          )}
          <FormControlLabel
            style={{
              display: "flex",
              justifyContent: "center",
              marginRight: "15px",
              marginLeft: 0
            }}
            control={<IOSSwitch checked={checked} onChange={handleChange} />}
          />
        </>
      )}
      {afterLabel && (
        <>
          <FormControlLabel
            style={{
              display: "flex",
              justifyContent: "center",
              marginLeft: "15px",
              marginRight: 0
            }}
            control={<IOSSwitch checked={checked} onChange={handleChange} />}
          />
          {!withoutLabel && (
            <Typography
              color={checked ? "secondary.tint90" : "secondary.tint40"}
            >
              {variant === "onOrOff"
                ? onOrOff
                : variant === "activeOrInactive"
                ? activeOrInactive
                : yesOrNo}
            </Typography>
          )}
        </>
      )}
    </FormGroup>
  );
}
